import { makeAutoObservable } from "mobx";
import { t, translate } from "../I18n";
import { formatFulfillmentMethodType } from "./formatFulfillmentMethodType";
export class PProductUnavailabilityDetails {
    constructor(params) {
        this.availability = params.availability;
        this.restaurant = params.restaurant;
        makeAutoObservable(this);
    }
    get reasons() {
        return this.availability.unavailabilityReasons;
    }
    get error() {
        if (this.reasons.isEmpty) {
            return null;
        }
        if (this.reasons.includes("Visibility")) {
            return {
                type: "VisibilityUnavailability",
                message: translate(t.menu.productTemporarilyUnavailable),
            };
        }
        if (this.reasons.includes("TemporarilyUnavailable") ||
            this.reasons.includes("Hidden") ||
            this.reasons.includes("OutdatedPreorderSettings")) {
            return {
                type: "TemporarilyUnavailable",
                message: translate(t.menu.productTemporarilyUnavailable),
            };
        }
        if (this.reasons.includes("Preorder")) {
            return {
                type: "PreorderUnavailability",
                message: translate(t.cart.errors.productUnavailableAtThisTime),
            };
        }
        if (this.reasons.includes("Schedule")) {
            return {
                type: "ScheduleUnavailability",
                message: translate(t.cart.errors.productUnavailableAtThisTime),
            };
        }
        if (this.parametersDetails.length > 0) {
            const result = {
                type: "ParametersUnavailability",
                message: `${translate(t.cart.errors.invalidProductVariant)}: ${this.parametersDetails.join(", ")}.`,
            };
            return result;
        }
        if (this.reasons.includes("PriceAvailability") ||
            this.reasons.includes("ParametrizedAvailability")) {
            return {
                type: "ParametersUnavailability",
                message: translate(t.cart.errors.invalidProductVariant),
            };
        }
        return {
            type: "UnknownUnavailability",
            message: translate(t.cart.errors.productCantBeOrdered),
        };
    }
    get parametersDetails() {
        const { internal, custom } = this.availability.causingParameters;
        const details = [];
        if (!internal.fulfillmentMethod.isEmpty) {
            const key = translate(t.order.delivery_method);
            const value = internal.fulfillmentMethod
                .rawValues()
                .map((fulfillmentMethod) => formatFulfillmentMethodType(fulfillmentMethod))
                .join(", ");
            details.push(`${value} (${key})`);
        }
        if (!internal.splitToHalves.isEmpty) {
            details.push(translate(t.cart.errors.tooManyParts));
        }
        details.push(...custom.values.entries.mapOptional(([parameterType, choiceIds]) => {
            const parameter = this.restaurant.customParameterTypes.find(parameterType.id);
            if (parameter === null) {
                return null;
            }
            const choices = parameter.choices.objects
                .filtered((choice) => choiceIds.includes(choice.id))
                .map((choice) => choice.name).raw;
            return choices.length > 0
                ? `${choices.join(", ")} (${parameter.name})`
                : `(${parameter.name})`;
        }).raw);
        return details;
    }
}
